import React from 'react';
import { UserBasicInfoResp, UserGradeInfoResp } from 'domain/payload/response/user/UserViewResp';

interface UserBasicInfoCardProps {
  userInfo: UserBasicInfoResp | null;
  gradeInfo?: UserGradeInfoResp | null;
  onWhatsAppClick: (phoneNumber: string) => void;
}

const UserBasicInfoCard: React.FC<UserBasicInfoCardProps> = ({ 
  userInfo,
  gradeInfo
}) => {
  const handleWhatsAppClick = (phoneNumber: string) => {
    if (!phoneNumber) return;
    
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    let whatsappNumber = cleanNumber;
    
    if (whatsappNumber.startsWith('0')) {
      whatsappNumber = '62' + whatsappNumber.substring(1);
    }
    
    window.open(`https://wa.me/${whatsappNumber}`, '_blank');
  };

  return (
    <div className="card h-100 border">
      <div className="card-header bg-light border-bottom">
        <h6 className="mb-0 fw-bold">Basic Info</h6>
      </div>
      <div className="card-body">
        <div className="d-flex flex-column align-items-center">
          <div className="mb-4">
            <div className="bg-light rounded-circle d-flex align-items-center justify-content-center" 
                 style={{ width: '100px', height: '100px' }}>
              {userInfo?.profilePicture ? (
                <img 
                  src={userInfo.profilePicture} 
                  alt="Profile" 
                  className="rounded-circle"
                  style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                />
              ) : (
                <i className="fa-solid fa-user fa-3x text-secondary"></i>
              )}
            </div>
          </div>

          <h4 className="fw-bold mb-2">{userInfo?.name || 'N/A'}</h4>

          {gradeInfo && (
            <div className="mb-3 d-flex align-items-center gap-2">
              <span 
                className="badge px-3 py-2 fs-6 rounded-pill text-white fw-semibold"
                style={{
                  backgroundColor: (() => {
                    const clean = (gradeInfo.overall || '').toUpperCase().replace('GRADE', '').trim();
                    if (clean.startsWith('A')) return '#10B981'; // Hijau
                    if (clean.startsWith('B')) return '#EAB308'; // Kuning
                    if (clean.startsWith('C')) return '#F97316'; // Oranye
                    return '#EF4444'; // Merah
                  })()
                }}
              >
                <i className="fa-solid fa-award me-1"></i>
                {gradeInfo.overall} ({gradeInfo.score.toFixed(1)} pts)
              </span>
            </div>
          )}

          <div className="w-100">
            <div className="row g-3">
              <div className="col-12">
                <div className="d-flex align-items-start">
                  <div className="me-3 text-muted">
                    <i className="fa-solid fa-envelope"></i>
                  </div>
                  <div>
                    <div className="text-muted small mb-1">Email</div>
                    <div className="fw-medium">{userInfo?.email || 'N/A'}</div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="d-flex align-items-start">
                  <div className="me-3 text-muted">
                    <i className="fa-solid fa-phone"></i>
                  </div>
                  <div>
                    <div className="text-muted small mb-1">Phone</div>
                    {userInfo?.phone ? (
                      <div 
                        className="fw-medium d-flex align-items-center text-decoration-none cursor-pointer"
                        onClick={() => handleWhatsAppClick(userInfo.phone)}
                        style={{ cursor: 'pointer' }}
                        title="Click to chat on WhatsApp"
                      >
                        {userInfo.phone}
                        <i className="fa-brands fa-whatsapp ms-2 text-success"></i>
                      </div>
                    ) : (
                      <div className="text-muted">No phone number</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="d-flex align-items-start">
                  <div className="me-3 text-muted">
                    <i className="fa-solid fa-users"></i>
                  </div>
                  <div>
                    <div className="text-muted small mb-1">Tribes</div>
                    <div className="fw-medium">
                      {userInfo?.tribes && userInfo.tribes.length > 0 
                        ? userInfo.tribes.join(', ') 
                        : 'No tribes'}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserBasicInfoCard;